import request from '../request'

// 关于我们
export function aboutUsApi() {
  return request.get('/api/common/contact_us')
}

// 更新联系方式
export function updateAboutUsApi(params:any) {
  return request.put('/api/common/contact_us/1', params)
}